import React from 'react';

export default function currencyFormatterPrice(value) {
    const formatter = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2
    })
    return formatter.format(value)
}
